import { Injectable, Signal, signal } from '@angular/core';

export interface TooltipState {
  show: boolean;
  text: string;
}

@Injectable()
export class CopyCodeTooltipService {
  private tooltipState = signal<TooltipState>({
    show: false,
    text: '',
  });

  getTooltipState(): Signal<TooltipState> {
    return this.tooltipState.asReadonly();
  }

  toggleShow(tooltipState: TooltipState): void {
    this.tooltipState.set(tooltipState);
  }
}
